<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Órdenes a Proveedores Pendientes</strong>
            <p class="descripcion">Órdenes emitidas en el período, con saldo al día de la fecha.</p>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !proveedor,
                                  'fa fa-remove': proveedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchProveedorModal"
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import exportOrdenesProveedores from '../../mixins/export_xls_ordenes_proveedores';
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appSearchProveedor: SearchProveedor,
    appMensaje: Mensaje
  },
  mixins: [
    exportOrdenesProveedores,
    msjModal
  ],
  data () {
    return {
      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      proveedor: null,

      labelCols: 2,
    }
  },
  computed: {
    proveedorNombre() {
      return this.proveedor? this.proveedor.nombre.trim() : '';
    },
  },
  created() {
    
  },  
  methods: {
    exportXls () {
      let execute = true;

      let proveedorId = 0;
      if (this.proveedor) {
        proveedorId = this.proveedor.id;
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        proveedorId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('ordenesproveedores/getRptOrdenesPendientes', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptOrdenesProveedores = this.$store.getters['ordenesproveedores/rptOrdenesProveedores'];

            if (rptOrdenesProveedores) {
              if (rptOrdenesProveedores.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              this.exportXLSRptOrdenesPendientes(rptOrdenesProveedores);
            } else {
              this.showErrorMsj('No hay datos para exportar')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    seleccionarProveedor() {
      if (this.proveedor) {
        this.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(item) {
      this.proveedor = item;
      this.$refs.searchProveedorModal.hide();
    },
  },
}
</script>

<style>
</style>
